import { c as _c } from "react/compiler-runtime";
import type { Entity, EntityOnboarding } from '@onefootprint/request-types/dashboard';
import { useQuery } from '@tanstack/react-query';
import { transformDocuments } from '@/entity/hooks/use-documents';
import { getOnboardingQueries } from '../../../utils/onboarding-queries';
const useOnboardingDocuments = (entity, onboarding) => {
  const $ = _c(12);
  let t0;
  if ($[0] !== entity || $[1] !== onboarding) {
    t0 = getOnboardingQueries(entity, onboarding);
    $[0] = entity;
    $[1] = onboarding;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== t0.documents) {
    t1 = {
      ...t0.documents,
      select: transformDocuments
    };
    $[3] = t0.documents;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    data,
    isPending,
    error
  } = useQuery(t1);
  let t2;
  if ($[5] !== data || $[6] !== onboarding) {
    t2 = data?.filter(d => d.onboardingId === onboarding.id);
    $[5] = data;
    $[6] = onboarding;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== error || $[9] !== isPending || $[10] !== t2) {
    t3 = {
      documents: t2,
      isPending,
      error
    };
    $[8] = error;
    $[9] = isPending;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};
export default useOnboardingDocuments;